import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getBaseReservation } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { ServiceName } from '../../../../components/commander-ui';

const ServiceLabel = ({ reservation }: $TSFixMe) => {
    const serviceId = get('serviceId', reservation);
    return <ServiceName id={serviceId} />;
};

export default connect(
    createStructuredSelector({
        reservation: (state: $TSFixMe, { serviceOrderId }: $TSFixMe) =>
            getBaseReservation(state, { id: serviceOrderId }),
    })
)(ServiceLabel);
